import React, { useState, useCallback, useEffect } from "react";
import { Container } from "./styles";
import CKEditor from "ckeditor4-react";
CKEditor.editorUrl = "https://cdn.ckeditor.com/4.16.0/full/ckeditor.js";
const NewTextEditor = (props) => {
  useEffect(() => {
    didMount();
  }, [props.default]);

  const didMount = useCallback(async () => {
    if (props.default) {
      props.text.current = props.default;
    }
  }, [props.default]);

  const handleChange = useCallback(
    ({ editor }) => {
      const data = editor.getData();
      props.text.current = data;
    },
    [props.text]
  );

  return (
    <Container>
      <style>{`
        .cke_button_label {
          display: none !important;
        }

        .cke_toolbar {
          display: flex !important;
          justify-content: space-around !important;
        }

        [class$="_label"] {
          display: none !important;
        }

        #cke_1_toolbox { 
          display: flex !important;
        }
      `}</style>
      <CKEditor data={props.default} onChange={handleChange} />
    </Container>
  );
};

export default NewTextEditor;
